import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { GoChevronUp, GoChevronDown } from 'react-icons/go';
import Tooltip from 'components/workflow/generic/controls/common/tooltip';
import Preferences from 'context/preferences';

export default class BlobHeaderToggle extends Component {
  constructor(props) {
    super(props);
    this.state = { collapsed: this.read() };
  }

  read() {
    return !!Preferences.get("app.blobHeaderCollapsed", this.props.scope);
  }

  componentDidMount() {
    this.unsubscribe = Preferences.subscribe(() => {
      const next = this.read();
      if (next !== this.state.collapsed) {
        this.setState({ collapsed: next });
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  handleClick = () => {
    Preferences.set("app.blobHeaderCollapsed", !this.state.collapsed, this.props.scope);
  }

  render() {
    const Icon = this.state.collapsed ? GoChevronDown : GoChevronUp;
    const title = this.state.collapsed ? "Expand" : "Collapse";

    if (this.props.compact) {
      return (
        <button
          type="button"
          className="blob-header-toggle blob-header-toggle-link"
          aria-label={title}
          onClick={this.handleClick}
        >
          <Icon/>
        </button>
      );
    }

    return (
      <Tooltip text={title}>
        <Button variant="light" size="sm" className="blob-header-toggle" onClick={this.handleClick}>
          <Icon/>
        </Button>
      </Tooltip>
    );
  }
}
